import "./OrdersTable.css";
import {
  useExpanded,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { LabOrder } from "pwapi";

import OrdersColumns from "./OrdersColumns";
import OrdersTableView from "./OrdersTableView";

type OrdersTableProps = {
  orders: LabOrder[];
  columns: any[];
};

const OrdersTable = ({ columns, orders = [] }: OrdersTableProps) => {
  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: orders,
      autoResetExpanded: false,
      defaultColumn: {
        sortDescFirst: true,
      },
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  return (
    <OrdersTableView
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
    />
  );
};

export default OrdersColumns(OrdersTable, { hasFlagReason: true });
